import config from "../environment/environment-config";
import {
  convertToAddToCartEvModel,
  EventData,
  EventType,
  TTEcommerceAnalyticsTrackingData,
} from "../api/model/data-layer";

// TT Custom - Removed unused method getProductAnalyticsData

const credentials: RequestInit = { credentials: "same-origin" };

export const trackGoogleAnalyticsEvent = async (
  type: EventType,
  data: EventData
): Promise<void> => {
  try {
    const googleAnalyticsApiUrl = config.apiUrls.googleAnalyticsApi;
    const url = `${googleAnalyticsApiUrl}/product/${data.productCode}`;
    const res = await fetch(url, credentials);
    if (!res.ok) throw new Error();

    const productData: TTEcommerceAnalyticsTrackingData = await res.json();

    if (type === EventType.addToCart) {
      const evData = convertToAddToCartEvModel(productData, data);
      window.mediator.publish("trackAddToCart", evData);
    }

    if (type === EventType.productClick) {
      const evData = {
        data: { ...productData, position: data.position },
        ...data,
      };
      window.mediator.publish("trackProductClick", evData);
    }

    if (type === EventType.addToWishlist) {
      const evData = {
        productData: {
          ...productData,
          origin: data.origin,
          quantity: data.quantity,
        },
      };
      window.mediator.publish("pushAddToWishlist", evData);
    }
  } catch (e) {
    console.error(e);
  }
};

export const trackGAEventForBulkProduct = async (
  type: EventType,
  data: EventData[]
): Promise<void> => {
  try {
    const googleAnalyticsApiUrl = config.apiUrls.googleAnalyticsApi;
    const urls = data.map(
      (item) => `${googleAnalyticsApiUrl}/product/${item.productCode}`
    );

    const results = await Promise.all(
      urls.map(async (url) => {
        const res = await fetch(url);
        return res;
      })
    );

    if (results.some((res) => !res.ok)) throw new Error();

    const productsData: TTEcommerceAnalyticsTrackingData[] = await Promise.all(
      results.map(async (res) => await res.json())
    );

    if (type === EventType.addToCart) {
      const products = productsData.map((product, index) => ({
        ...product,
        quantity: data[index].quantity,
      }));
      const evData = { addToCartData: products, cartData: data[0] };
      window.mediator.publish("trackAddMultipleToCart", evData);
    }

    if (type === EventType.addToWishlist) {
      const products = productsData.map((product, index) => ({
        ...product,
        quantity: data[index].quantity,
      }));

      const evData = { entriesData: products, origin: data[0].origin };
      console.log("exData", evData);
      window.mediator.publish("pushAddMultipleToWishlist", evData);
    }
  } catch (e) {
    console.error(e);
  }
};
